// extracted by mini-css-extract-plugin
module.exports = {"projectCard":"Project_projectCard__2enaq","description":"Project_description__1twzV","image":"Project_image__1CZAW"};